import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useNativeBridge } from '@/context/NativeBridgeContext'
import { trans } from '@/helpers/trans'
import { NotificationTappedPayload } from '@/types'

export const ConnectedNotificationTapRouting: FC = () => {
    const bridge = useNativeBridge()
    const navigate = useNavigate()

    useEffect(() => {
        const communicationPath = `/${trans('nav.communication.link')}`
        const newsfeedPath = `${communicationPath}/${trans('nav.communication.newsfeed.link')}`
        const messagesPath = `${communicationPath}/${trans('nav.communication.messages.link')}`

        return bridge.onNotificationTapped((payload: NotificationTappedPayload) => {
            if (typeof payload.channel_id === 'string') {
                navigate(`${messagesPath}/${payload.channel_id}`)
                return
            }

            if (typeof payload.activity_id === 'string') {
                navigate(newsfeedPath, { state: { focusActivityId: payload.activity_id } })
                return
            }

            navigate(typeof payload.route === 'string' ? payload.route : '/')
        })
    }, [bridge, history])

    return null
}
